import type { OngoingRequestsController } from "./types/OngoingRequestsController";

export const makeAbortAll =
  ({
    ongoingRequestsControllers,
  }: {
    ongoingRequestsControllers: OngoingRequestsController;
  }) =>
  ({ reason }: { reason: string }) => {
    const ongoingRequestsControllersSymbols = Object.getOwnPropertySymbols(
      ongoingRequestsControllers,
    );

    ongoingRequestsControllersSymbols.forEach((symbol) =>
      ongoingRequestsControllers[symbol]!.abort(reason),
    );
  };
